/* global axios */
import ApiClient from './ApiClient';

class ImportMappingsAPI extends ApiClient {
  constructor() {
    super('import_mappings', { accountScoped: true });
  }

  index() {
    return axios.get(this.url);
  }

  create(name, mappingConfig) {
    return axios.post(this.url, {
      import_mapping: { name, mapping_config: mappingConfig },
    });
  }

  update(id, name, mappingConfig) {
    return axios.patch(`${this.url}/${id}`, {
      import_mapping: { name, mapping_config: mappingConfig },
    });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ImportMappingsAPI();
